import { type CSSProperties, type FC, type ReactNode } from 'react';
import { V4 } from '../tokens';
import { PREVIEW_BAR } from '@utils/featureRollout/strings';

// Barra de VISTA PREVIA per-usuario (Item E #2). Se muestra mientras el operador (no-root) mira
// la versión nueva en preview, sin que el comercio haya cambiado de versión. Le recuerda que es
// una vista previa personal y le da "Volver a la actual" (apaga el preview; NO revierte nada del
// comercio). Copy en featureRollout/strings.ts. 100% inline styles V4.

export interface PreviewBarProps {
  // Apaga la vista previa per-usuario (stopPreview). NO toca la variante del comercio.
  onExit: () => void;
}

const EyeIcon: ReactNode = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const BackIcon: ReactNode = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    aria-hidden="true"
  >
    <path d="M11 5l-7 7 7 7M4 12h16" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const barStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  flexWrap: 'wrap',
  background: V4.secondaryFaded,
  border: `1px solid ${V4.secondaryLight2}`,
  borderRadius: 10,
  padding: '9px 12px',
  fontFamily: 'inherit',
};

const labelStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  color: V4.secondaryDark,
  fontSize: 12.5,
  fontWeight: 700,
  lineHeight: 1.4,
  minWidth: 0,
};

const backButton: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  background: V4.white,
  color: V4.secondaryDark,
  border: `1px solid ${V4.secondary}`,
  borderRadius: 999,
  padding: '6px 12px',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: 12.5,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export const PreviewBar: FC<PreviewBarProps> = ({ onExit }) => (
  <div style={barStyle} role="status">
    <span style={labelStyle}>
      {EyeIcon}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{PREVIEW_BAR.label}</span>
    </span>
    <button type="button" style={backButton} aria-label={PREVIEW_BAR.backAria} onClick={onExit}>
      {BackIcon}
      {PREVIEW_BAR.back}
    </button>
  </div>
);

export default PreviewBar;
